var render = function render(){
  var _vm$session$trials$_v, _vm$session$trials$_v2, _vm$session$trials$_v3, _vm$session$trials$_v9, _vm$session$trials$_v0, _vm$session$trials$_v1, _vm$session$trials$_v10, _vm$session$trials$_v11, _vm$session;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step-5 d-flex"
  }, [_c('v-snackbar', {
    attrs: {
      "color": _vm.sessionNotification.type === 'error' ? 'error' : _vm.sessionNotification.type === 'success' ? 'success' : _vm.sessionNotification.type === 'warning' ? 'warning' : 'info',
      "timeout": _vm.sessionNotification.type === 'error' || _vm.sessionNotification.type === 'warning' ? 10000 : 5000,
      "app": "",
      "top": "",
      "centered": "",
      "content-class": "session-notification-snackbar"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (_ref) {
        var attrs = _ref.attrs;
        return [_c('v-btn', _vm._b({
          attrs: {
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.sessionNotification.show = false;
            }
          }
        }, 'v-btn', attrs, false), [_vm._v(" Close ")])];
      }
    }]),
    model: {
      value: _vm.sessionNotification.show,
      callback: function ($$v) {
        _vm.$set(_vm.sessionNotification, "show", $$v);
      },
      expression: "sessionNotification.show"
    }
  }, [_vm._v(" " + _vm._s(_vm.sessionNotification.text) + " ")]), !_vm.leftMenuOpen && _vm.isTabletOrPhone ? _c('v-btn', {
    staticClass: "mobile-menu-toggle ui-no-zoom",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.leftMenuOpen = true;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-menu")])], 1) : _vm._e(), _vm.leftMenuOpen && _vm.isPhone ? _c('div', {
    staticClass: "mobile-overlay",
    on: {
      "click": function ($event) {
        _vm.leftMenuOpen = false;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "left-wrapper",
    class: {
      'mobile-open': _vm.leftMenuOpen || !_vm.isTabletOrPhone,
      'mobile-drawer': _vm.isTabletOrPhone
    }
  }, [_c('div', {
    staticClass: "left ui-no-zoom d-flex flex-column pa-2"
  }, [_c('div', {
    staticClass: "left-scroll d-flex flex-column"
  }, [_vm.showOpenInAppButton ? _c('v-btn', {
    staticClass: "mb-4 w-100",
    attrs: {
      "color": "primary-dark",
      "large": ""
    },
    on: {
      "click": _vm.openInApp
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cellphone-arrow-down")]), _vm._v(" Open in App ")], 1) : _vm._e(), _vm.isMonocularSession ? _c('v-alert', {
    staticClass: "monocular-beta-alert mb-4",
    attrs: {
      "type": "info",
      "dense": "",
      "outlined": "",
      "icon": false,
      "border": "left"
    }
  }, [_c('div', {
    staticClass: "monocular-beta-content"
  }, [_c('strong', [_vm._v("Monocular mode is in beta.")]), _c('br'), _c('a', {
    attrs: {
      "href": "https://www.opencap.ai/best-practices?variant=Monocular",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Best practices")]), _vm._v(" · "), _c('a', {
    attrs: {
      "href": "https://www.opencap.ai/get-started?variant=monocular",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Get started")]), _vm._v("."), _c('br'), _vm._v(" Jumping is not supported yet. Camera should be static at 30-45° angle. Keep the full body in frame, clearly visible (not blocked by objects or people), within 5 meters of the camera. ")])]) : _vm._e(), _c('ValidationObserver', {
    ref: "observer",
    staticClass: "d-flex flex-column",
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var invalid = _ref2.invalid;
        return [_vm.participantName ? _c('div', {
          staticClass: "participant-context mb-3"
        }, [_c('span', {
          staticClass: "participant-context__label"
        }, [_vm._v("Participant:")]), _c('span', {
          staticClass: "participant-context__name",
          attrs: {
            "title": _vm.participantName
          }
        }, [_vm._v(_vm._s(_vm.participantName))])]) : _vm._e(), _c('div', {
          staticClass: "d-flex align-center flex-wrap mb-2 trial-name-row"
        }, [_c('div', {
          staticClass: "flex-grow-1 min-width-0"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required|alpha_dash_custom",
            "name": "Trial name"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('v-text-field', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show_controls && !_vm.showOpenInAppButton,
                  expression: "show_controls && !showOpenInAppButton"
                }],
                staticClass: "flex-grow-0",
                attrs: {
                  "label": "Trial name",
                  "disabled": _vm.state !== 'ready',
                  "error": errors.length > 0,
                  "error-messages": errors[0],
                  "autocomplete": "off"
                },
                model: {
                  value: _vm.trialName,
                  callback: function ($$v) {
                    _vm.trialName = $$v;
                  },
                  expression: "trialName"
                }
              })];
            }
          }], null, true)
        })], 1)]), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.show_controls && !_vm.showOpenInAppButton,
            expression: "show_controls && !showOpenInAppButton"
          }],
          staticClass: "mb-4 w-100",
          attrs: {
            "disabled": _vm.recordingActionInFlight || _vm.recordingStopCooldownActive || _vm.lidarCooldownActive || _vm.state === 'ready' && (_vm.busy || invalid)
          },
          on: {
            "click": _vm.changeState
          }
        }, [_vm._v(" " + _vm._s(_vm.buttonCaption) + " ")]), _vm.state === 'recording' && _vm.n_cameras_connected >= _vm.n_calibrated_cameras ? _c('p', [_vm._v(" " + _vm._s(_vm.recordingStatusText) + " "), _vm.recordingDisplayFramerate ? [_vm._v(" at " + _vm._s(_vm.recordingDisplayFramerate) + " Hz")] : _vm._e(), _vm.isLidarRecordingEnabled ? [_vm._v(", " + _vm._s(_vm.lidarRecordingStatusText))] : _vm._e(), _vm._v(", do not refresh ")], 2) : _vm._e(), _vm.state === 'processing' ? _c('p', [_vm._v(_vm._s(_vm.processingProgressText))]) : _vm._e()];
      }
    }])
  }), _c('div', {
    staticClass: "show-removed-trials-sidebar mb-2 d-flex align-center"
  }, [_c('v-checkbox', {
    staticClass: "toolbar-checkbox",
    attrs: {
      "label": "Show removed trials",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.show_trashed,
      callback: function ($$v) {
        _vm.show_trashed = $$v;
      },
      expression: "show_trashed"
    }
  }), _c('v-spacer'), _c('div', {
    staticClass: "trial-legend-wrap"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": "Trial color legend",
      "aria-haspopup": "true",
      "aria-expanded": String(_vm.trialLegendOpen)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleTrialLegend.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-palette-outline")])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.trialLegendOpen,
      expression: "trialLegendOpen"
    }],
    staticClass: "trial-legend",
    attrs: {
      "role": "dialog",
      "aria-label": "Trial status"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "trial-legend__header"
  }, [_c('div', {
    staticClass: "trial-legend__title"
  }, [_vm._v("Trial status")]), _c('v-btn', {
    staticClass: "trial-legend__close",
    attrs: {
      "icon": "",
      "x-small": "",
      "aria-label": "Close trial status legend"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.closeTrialLegend.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3)])], 1)], 1), _c('div', {
    staticClass: "trials-wrapper flex-grow-1"
  }, [_c('div', {
    staticClass: "trials"
  }, _vm._l(_vm.filteredTrialsWithMenu, function (t, index) {
    return _c('div', {
      key: t.id,
      staticClass: "trial-row",
      attrs: {
        "item": t,
        "index": index
      }
    }, [_c('div', {
      ref: t.id,
      refInFor: true,
      staticClass: "my-1 trial d-flex justify-content-between",
      class: {
        selected: _vm.isSelected(t)
      }
    }, [_c('Status', {
      class: [_vm.trialClasses(t), 'flex-grow-1'],
      attrs: {
        "value": t
      },
      on: {
        "click": function ($event) {
          return _vm.loadTrial(t);
        }
      }
    }), _c('div', {}, [_vm.$vuetify.breakpoint.smAndDown ? [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.openTrialMenuSheet(t);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-menu")])], 1)] : _c('v-menu', {
      attrs: {
        "offset-y": "",
        "right": "",
        "close-on-content-click": "",
        "content-class": "trial-context-menu"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref4) {
          var on = _ref4.on,
            attrs = _ref4.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)];
        }
      }], null, true),
      model: {
        value: t.isMenuOpen,
        callback: function ($$v) {
          _vm.$set(t, "isMenuOpen", $$v);
        },
        expression: "t.isMenuOpen"
      }
    }, [_c('v-list', [t.name !== 'neutral' ? _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.closeMenuAndRename(t);
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Rename")])], 1) : _vm._e(), !t.trashed && t.name !== 'neutral' ? _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.closeMenuAndAnalysis(t);
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Analysis")])], 1) : _vm._e(), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.closeMenuAndEditTags(t);
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit Tags")])], 1), !t.trashed ? _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.closeMenuAndOpenTrashDialog(t);
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Trash")])], 1) : _vm._e(), t.trashed ? _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.closeMenuAndOpenRestoreDialog(t);
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Restore")])], 1) : _vm._e(), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.closeMenuAndOpenDeleteDialog(t);
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete permanently")])], 1)], 1)], 1)], 2)], 1), index < _vm.filteredTrialsWithMenu.length - 1 ? _c('v-divider', {
      staticClass: "mx-0 my-1"
    }) : _vm._e()], 1);
  }), 0)]), _c('v-bottom-sheet', {
    attrs: {
      "content-class": "bottom-sheet-rounded"
    },
    on: {
      "input": function (val) {
        return !val && (_vm.selectedTrialForMenu = null);
      }
    },
    model: {
      value: _vm.showTrialMenuSheet,
      callback: function ($$v) {
        _vm.showTrialMenuSheet = $$v;
      },
      expression: "showTrialMenuSheet"
    }
  }, [_c('v-sheet', {
    staticClass: "text-center trial-menu-sheet"
  }, [_vm.selectedTrialForMenu ? _c('v-list', [_vm.selectedTrialForMenu.name !== 'neutral' ? _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndRename(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-pencil")]), _c('span', [_vm._v("Rename")])], 1)])], 1) : _vm._e(), _vm.selectedTrialForMenu.name !== 'neutral' ? _c('v-divider') : _vm._e(), !_vm.selectedTrialForMenu.trashed && _vm.selectedTrialForMenu.name !== 'neutral' ? _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndAnalysis(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-chart-box")]), _c('span', [_vm._v("Analysis")])], 1)])], 1) : _vm._e(), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndEditTags(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-tag-multiple")]), _c('span', [_vm._v("Edit Tags")])], 1)])], 1), !_vm.selectedTrialForMenu.trashed ? _c('v-divider') : _vm._e(), !_vm.selectedTrialForMenu.trashed ? _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndOpenTrashDialog(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-delete-outline")]), _c('span', [_vm._v("Trash")])], 1)])], 1) : _vm._e(), _vm.selectedTrialForMenu.trashed ? _c('v-divider') : _vm._e(), _vm.selectedTrialForMenu.trashed ? _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndOpenRestoreDialog(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-restore")]), _c('span', [_vm._v("Restore")])], 1)])], 1) : _vm._e(), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndOpenDeleteDialog(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-delete-forever")]), _c('span', [_vm._v("Delete permanently")])], 1)])], 1)], 1) : _vm._e()], 1)], 1)], 1), _c('v-btn', {
    staticClass: "session-actions-toggle w-100",
    on: {
      "click": function ($event) {
        return _vm.toggleSessionMenuButtons();
      }
    }
  }, [_vm.showSessionMenuButtons ? _c('v-icon', [_vm._v("mdi-menu-down")]) : _c('v-icon', [_vm._v("mdi-menu-up")])], 1), _vm.showSessionMenuButtons ? _c('div', {
    staticClass: "session-actions-panel"
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show_controls,
      expression: "show_controls"
    }],
    staticClass: "w-100 session-action-btn",
    attrs: {
      "small": "",
      "disabled": _vm.busy || _vm.state !== 'ready'
    },
    on: {
      "click": _vm.openNewSessionSameSetupConfirm
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus-box-multiple")]), _vm._v(" " + _vm._s(_vm.newSessionSameSetupCopy.button) + " ")], 1), _c('ConfirmDialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "cancel-text": "Cancel",
      "confirm-text": "Create session",
      "confirm-color": "green darken-1"
    },
    on: {
      "cancel": function ($event) {
        _vm.new_session_same_setup_confirm_dialog = false;
      },
      "confirm": _vm.confirmNewSessionSameSetup
    },
    model: {
      value: _vm.new_session_same_setup_confirm_dialog,
      callback: function ($$v) {
        _vm.new_session_same_setup_confirm_dialog = $$v;
      },
      expression: "new_session_same_setup_confirm_dialog"
    }
  }, [_c('h3', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.newSessionSameSetupCopy.title))]), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" Starting a new session will leave this session page. ")]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" " + _vm._s(_vm.newSessionSameSetupCopy.body) + " ")])]), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show_controls,
      expression: "show_controls"
    }],
    staticClass: "mt-4 w-100 session-action-btn",
    attrs: {
      "small": "",
      "disabled": _vm.busy || _vm.state !== 'ready'
    },
    on: {
      "click": _vm.openNewSessionConfirm
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New session ")], 1), _c('ConfirmDialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "icon": "mdi-alert-circle",
      "icon-color": "orange",
      "cancel-text": "Cancel",
      "confirm-text": "Continue",
      "confirm-color": "orange darken-1"
    },
    on: {
      "cancel": function ($event) {
        _vm.new_session_confirm_dialog = false;
      },
      "confirm": _vm.confirmNewSession
    },
    model: {
      value: _vm.new_session_confirm_dialog,
      callback: function ($$v) {
        _vm.new_session_confirm_dialog = $$v;
      },
      expression: "new_session_confirm_dialog"
    }
  }, [_vm.newSessionCopy.title ? _c('h3', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.newSessionCopy.title))]) : _vm._e(), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" " + _vm._s(_vm.newSessionCopy.body) + " ")]), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" " + _vm._s(_vm.newSessionCopy.detail) + " ")])]), _c('v-dialog', {
    attrs: {
      "content-class": "app-dialog",
      "width": _vm.$vuetify.breakpoint.smAndDown ? '100%' : '500',
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.show_controls,
            expression: "show_controls"
          }],
          ref: "shareDialogActivator",
          staticClass: "mt-4 w-100 session-action-btn",
          attrs: {
            "small": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-share-variant")]), _vm._v(" Share session publicly ")], 1)];
      }
    }], null, false, 2063604370),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5"
  }, [_vm._v(" Share session publicly ")]), _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "id": "session-public",
      "name": "session-public",
      "label": "Make session public"
    },
    on: {
      "change": function ($event) {
        return _vm.setPublic($event);
      }
    },
    model: {
      value: _vm.session.public,
      callback: function ($$v) {
        _vm.$set(_vm.session, "public", $$v);
      },
      expression: "session.public"
    }
  }), _c('p', [_vm._v("Making your session public will make your analyses public too.")]), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.session.public,
      expression: "session.public"
    }]
  }, [_c('h3', {
    staticClass: "mb-2"
  }, [_vm._v("Share on")]), _c('ShareNetwork', {
    staticClass: "mr-2",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "network": "facebook",
      "url": _vm.sessionUrl,
      "title": "OpenCap session"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "aria-hidden": "false"
    }
  }, [_vm._v("mdi-facebook")]), _vm._v("  Facebook")], 1)], 1), _c('ShareNetwork', {
    staticClass: "mr-2",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "network": "twitter",
      "url": _vm.sessionUrl,
      "title": "OpenCap session"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "aria-hidden": "false"
    }
  }, [_vm._v("mdi-twitter")]), _vm._v("  Twitter")], 1)], 1), _c('ShareNetwork', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "network": "linkedin",
      "url": _vm.sessionUrl,
      "title": "OpenCap session"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "aria-hidden": "false"
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v("  LinkedIn")], 1)], 1), _c('v-text-field', {
    staticClass: "mt-5",
    attrs: {
      "label": "Alternatively, copy this link",
      "readonly": "",
      "autocomplete": "off"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": "",
            "disabled": !_vm.sessionUrl,
            "title": "Copy to clipboard"
          },
          on: {
            "click": _vm.copySessionUrlToClipboard
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-copy")])], 1)];
      },
      proxy: true
    }], null, false, 1196498860),
    model: {
      value: _vm.sessionUrl,
      callback: function ($$v) {
        _vm.sessionUrl = $$v;
      },
      expression: "sessionUrl"
    }
  })], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" Close ")])], 1)], 1)], 1), _c('v-btn', {
    staticClass: "mt-4 w-100 session-action-btn",
    attrs: {
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showArchiveDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-download-outline")]), _vm._v(" Download data ")], 1), _c('v-dialog', {
    attrs: {
      "content-class": "app-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.showArchiveDialog,
      callback: function ($$v) {
        _vm.showArchiveDialog = $$v;
      },
      expression: "showArchiveDialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-download")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_vm.isArchiveInProgress & !_vm.isArchiveDone ? _c('p', [_c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "indeterminate": "",
      "color": "grey",
      "size": "14",
      "width": "2"
    }
  }), _vm._v(" Download in progress ")], 1) : _vm._e(), !(_vm.isArchiveInProgress || _vm.isArchiveDone) ? _c('p', [_vm._v(" Do you want to download all the data from session "), _c('code', [_vm._v(_vm._s(_vm.session.id))]), _vm._v("? (This can take several minutes). ")]) : _vm._e(), _vm.isArchiveDone ? _c('p', [_vm._v(" The archive has been successfully generated. Click on data.zip to download. ")]) : _vm._e()])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.showArchiveDialog = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _vm.isArchiveDone ? _c('v-btn', {
    attrs: {
      "href": _vm.archiveUrl,
      "download": "data.zip"
    }
  }, [_vm._v(" data.zip ")]) : _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": "",
      "disabled": _vm.isArchiveInProgress
    },
    on: {
      "click": function ($event) {
        return _vm.downloadSessionArchive(_vm.session.id);
      }
    }
  }, [_vm._v(" Download ")])], 1)], 1)], 1), _vm.isSyncDownloadAllowed ? _c('v-btn', {
    staticClass: "mt-4 w-100",
    attrs: {
      "small": "",
      "disabled": _vm.downloading
    },
    on: {
      "click": _vm.onDownloadData
    }
  }, [!_vm.downloading ? _c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-download")]) : _vm._e(), _vm.downloading ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "indeterminate": "",
      "color": "grey",
      "size": "14",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" Download data (old) ")], 1) : _vm._e(), _c('v-btn', {
    staticClass: "mt-4 w-100 session-action-btn",
    attrs: {
      "small": "",
      "disabled": !_vm.hasKinematicsAvailable
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'Dashboard',
          params: {
            id: _vm.session.id,
            trialId: _vm.trial.name
          }
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-view-dashboard-outline")]), _vm._v(" Dashboard kinematics ")], 1), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show_controls,
      expression: "show_controls"
    }],
    staticClass: "mt-4 w-100 session-action-btn",
    attrs: {
      "small": "",
      "disabled": _vm.busy || _vm.state !== 'ready'
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'SelectSession'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to session list ")], 1)], 1) : _vm._e()], 1), _vm.leftMenuOpen && _vm.isTabletOrPhone ? _c('v-btn', {
    staticClass: "sidebar-toggle-btn ui-no-zoom",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.leftMenuOpen = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "main-content d-flex flex-grow-1"
  }, [_vm.showOpenInAppButton && !_vm.trial ? _c('div', {
    staticClass: "open-in-app-center d-flex flex-column align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mb-4",
    attrs: {
      "size": "80",
      "color": "primary-dark"
    }
  }, [_vm._v("mdi-cellphone-arrow-down")]), _c('h2', {
    staticClass: "white--text mb-4 text-center"
  }, [_vm._v("Ready to Record")]), _vm._m(4), _c('v-btn', {
    staticClass: "open-in-app-btn",
    attrs: {
      "color": "primary-dark",
      "x-large": ""
    },
    on: {
      "click": _vm.openInApp
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-launch")]), _vm._v(" Open in App ")], 1), _c('v-alert', {
    staticClass: "monocular-beta-alert mt-6 mx-4",
    attrs: {
      "type": "info",
      "dense": "",
      "outlined": "",
      "border": "left"
    }
  }, [_c('div', {
    staticClass: "monocular-beta-content"
  }, [_c('strong', [_vm._v("Monocular mode is in beta.")]), _vm._v(" Jumping is not supported yet. Camera must be static at 30-45° angle. Keep the full body in frame, clearly visible (not blocked by objects or people), within 5 meters of the camera. "), _c('div', {
    staticClass: "d-flex flex-wrap mt-2"
  }, [_c('v-btn', {
    staticClass: "mr-2 mb-1",
    attrs: {
      "x-small": "",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.window.open('https://www.opencap.ai/best-practices?variant=Monocular', '_blank');
      }
    }
  }, [_vm._v("Best practices")]), _c('v-btn', {
    staticClass: "mb-1",
    attrs: {
      "x-small": "",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.window.open('https://www.opencap.ai/get-started?variant=monocular', '_blank');
      }
    }
  }, [_vm._v("Get started")])], 1)])])], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showOpenInAppButton || _vm.trial,
      expression: "!showOpenInAppButton || trial"
    }],
    staticClass: "viewer flex-grow-1"
  }, [_vm.trial ? _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "flex": "1 1 0",
      "min-height": "0",
      "height": "100%"
    }
  }, [_vm.has3DData ? _c('div', {
    staticClass: "mocap-wrapper flex-grow-1"
  }, [_c('div', {
    ref: "mocap",
    staticClass: "mocap-inner",
    attrs: {
      "id": "mocap"
    }
  }), !_vm.sceneReady ? _c('div', {
    staticClass: "mocap-loading-overlay d-flex align-center justify-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey lighten-1",
      "size": "40",
      "width": "3"
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "session-empty-state d-flex flex-column align-center justify-center text-center flex-grow-1"
  }, [_c('v-icon', {
    staticClass: "mb-3",
    attrs: {
      "size": "56",
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-cube-off-outline")]), _c('h3', {
    staticClass: "mb-2"
  }, [_vm._v("No 3D motion data for this trial")]), _c('p', {
    staticClass: "mb-0 px-4"
  }, [_vm._v("This trial doesn’t have motion data to visualize. If videos exist, you can still preview them on the right.")])], 1), _vm.trial && !_vm.isMobileOrTablet ? _c('div', {
    staticClass: "video-controls ui-no-zoom d-flex flex-wrap align-center pa-2"
  }, [_c('v-text-field', {
    staticClass: "time-input",
    attrs: {
      "label": "Time (s)",
      "type": "number",
      "step": 0.01,
      "value": _vm.time,
      "disabled": _vm.videoControlsDisabled || _vm.state !== 'ready',
      "autocomplete": "off"
    },
    on: {
      "input": _vm.onChangeTime
    }
  }), _c('v-slider', {
    staticClass: "mb-2 flex-grow-1 timeline-slider",
    attrs: {
      "value": _vm.frame,
      "min": 0,
      "max": _vm.frames.length - 1,
      "disabled": _vm.videoControlsDisabled,
      "hide-details": ""
    },
    on: {
      "input": _vm.onNavigate
    }
  }), _c('div', {
    staticClass: "playback-controls-inline d-flex align-center"
  }, [_vm.has3DData ? _c('CameraViewControls', {
    staticClass: "mr-2",
    attrs: {
      "value": _vm.cameraView,
      "follow": _vm.followSubject,
      "disabled": !_vm.sceneReady
    },
    on: {
      "change-view": _vm.setCameraView,
      "update:follow": _vm.setFollowSubject
    }
  }) : _vm._e(), _c('VideoNavigation', {
    staticClass: "playback-navigation",
    attrs: {
      "playing": _vm.playing,
      "value": _vm.frame,
      "maxFrame": _vm.frames.length - 1,
      "loop": _vm.loopPlayback,
      "show-loop-toggle": true,
      "disabled": _vm.videoControlsDisabled
    },
    on: {
      "play": function ($event) {
        return _vm.togglePlay(true);
      },
      "pause": function ($event) {
        return _vm.togglePlay(false);
      },
      "toggle-loop": _vm.toggleLoopPlayback,
      "input": _vm.onNavigate
    }
  }), _c('SpeedControl', {
    staticClass: "playback-speed ml-2",
    attrs: {
      "disabled": _vm.videoControlsDisabled
    },
    model: {
      value: _vm.playSpeed,
      callback: function ($$v) {
        _vm.playSpeed = $$v;
      },
      expression: "playSpeed"
    }
  })], 1)], 1) : _vm._e()]) : _vm.trialLoading ? _c('div', {
    staticClass: "flex-grow-1 d-flex align-center justify-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey",
      "size": "30",
      "width": "4"
    }
  })], 1) : _c('div', {
    staticClass: "session-empty-state d-flex flex-column align-center justify-center text-center"
  }, [_c('v-icon', {
    staticClass: "mb-3",
    attrs: {
      "size": "56",
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-chart-box-outline")]), _c('h3', {
    staticClass: "mb-2"
  }, [_vm._v("No data selected/recorded")]), _vm.show_controls ? _c('p', {
    staticClass: "mb-0 px-4"
  }, [_vm._v("Type a trial name on the left and click Start recording or select a trial from the list.")]) : _c('p', {
    staticClass: "mb-0 px-4"
  }, [_vm._v("Select a trial from the list to view motion data.")])], 1)]), _c('div', {
    staticClass: "right d-flex flex-column",
    style: _vm.mobileVideoPanelStyle
  }, [_c('div', {
    staticClass: "videos d-flex flex-column"
  }, _vm._l(_vm.videos, function (video, index) {
    return _c('video', {
      key: _vm.videoKey(video, index),
      ref: `video-${index}`,
      refInFor: true,
      staticClass: "video-element",
      attrs: {
        "muted": "",
        "playsinline": "",
        "src": video.media,
        "crossorigin": "anonymous",
        "preload": "metadata"
      },
      domProps: {
        "muted": true
      },
      on: {
        "loadedmetadata": function ($event) {
          return _vm.onVideoLoadedMetadata(index);
        },
        "ended": function ($event) {
          return _vm.onVideoEnded(index);
        }
      }
    });
  }), 0), _vm.showCamSizeButton && !_vm.videoControlsDisabled ? _c('v-btn-toggle', {
    staticClass: "cam-size-overlay ui-no-zoom",
    attrs: {
      "value": _vm.mobileVideoSizeIndex,
      "mandatory": "",
      "dense": ""
    },
    on: {
      "change": function ($event) {
        _vm.mobileVideoSizeIndex = $event;
      }
    }
  }, [_c('v-btn', {
    staticClass: "cam-size-segment",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("S")]), _c('v-btn', {
    staticClass: "cam-size-segment",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("M")]), _c('v-btn', {
    staticClass: "cam-size-segment",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("L")])], 1) : _vm._e(), _vm.isMobileOrTablet ? _c('div', {
    staticClass: "right-spacer"
  }) : _vm._e(), _vm.isMobileOrTablet && _vm.trial ? _c('div', {
    staticClass: "playback-controls ui-no-zoom"
  }, [_c('div', {
    staticClass: "playback-timeline-mobile d-flex align-center px-1"
  }, [_c('v-text-field', {
    staticClass: "time-input mr-2",
    attrs: {
      "label": "Time (s)",
      "type": "number",
      "step": 0.01,
      "value": _vm.time,
      "disabled": _vm.videoControlsDisabled || _vm.state !== 'ready',
      "dense": "",
      "hide-details": "",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.onChangeTime
    }
  }), _c('v-slider', {
    staticClass: "flex-grow-1 timeline-slider",
    attrs: {
      "value": _vm.frame,
      "min": 0,
      "max": _vm.frames.length - 1,
      "disabled": _vm.videoControlsDisabled,
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.onNavigate
    }
  })], 1), _c('div', {
    staticClass: "playback-controls-row"
  }, [_vm.has3DData ? _c('CameraViewControls', {
    attrs: {
      "value": _vm.cameraView,
      "follow": _vm.followSubject,
      "disabled": !_vm.sceneReady
    },
    on: {
      "change-view": _vm.setCameraView,
      "update:follow": _vm.setFollowSubject
    }
  }) : _vm._e(), _c('VideoNavigation', {
    staticClass: "playback-navigation",
    attrs: {
      "playing": _vm.playing,
      "value": _vm.frame,
      "maxFrame": _vm.frames.length - 1,
      "loop": _vm.loopPlayback,
      "show-loop-toggle": true,
      "show-skip-buttons": false,
      "disabled": _vm.videoControlsDisabled
    },
    on: {
      "play": function ($event) {
        return _vm.togglePlay(true);
      },
      "pause": function ($event) {
        return _vm.togglePlay(false);
      },
      "toggle-loop": _vm.toggleLoopPlayback,
      "input": _vm.onNavigate
    }
  }), _c('SpeedControl', {
    staticClass: "playback-speed",
    attrs: {
      "disabled": _vm.videoControlsDisabled
    },
    model: {
      value: _vm.playSpeed,
      callback: function ($$v) {
        _vm.playSpeed = $$v;
      },
      expression: "playSpeed"
    }
  })], 1)]) : _vm._e()], 1)]), _c('v-dialog', {
    attrs: {
      "content-class": "compact-rename-dialog app-dialog",
      "max-width": "420",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.trial_rename_dialog,
      callback: function ($$v) {
        _vm.trial_rename_dialog = $$v;
      },
      expression: "trial_rename_dialog"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "dialog-close-btn",
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function ($event) {
        _vm.trial_rename_dialog = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "orange"
    }
  }, [_vm._v("mdi-rename-box")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [((_vm$session$trials$_v = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v === void 0 ? void 0 : _vm$session$trials$_v.status) === 'processing' || ((_vm$session$trials$_v2 = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v2 === void 0 ? void 0 : _vm$session$trials$_v2.status) === 'uploading' ? _c('p', {
    staticClass: "text-orange"
  }, [_vm._v(" You can't rename a trial while it's being uploaded or processed. Please wait before attempting to rename the trial. ")]) : _c('p', [_vm._v(" Insert a new name for trial " + _vm._s((_vm$session$trials$_v3 = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v3 === void 0 ? void 0 : _vm$session$trials$_v3.name) + ": ")]), _c('ValidationObserver', {
    ref: "observer_tr",
    staticClass: "d-flex flex-column",
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref6) {
        var _vm$session$trials$_v4, _vm$session$trials$_v7, _vm$session$trials$_v8;
        var invalid = _ref6.invalid;
        return [_c('ValidationProvider', {
          attrs: {
            "rules": {
              required: true,
              alpha_dash_custom: true,
              unique_trial_name: [_vm.session.trials, (_vm$session$trials$_v4 = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v4 === void 0 ? void 0 : _vm$session$trials$_v4.name]
            },
            "name": "Trial name"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref7) {
              var _vm$session$trials$_v5, _vm$session$trials$_v6;
              var errors = _ref7.errors;
              return [_c('v-text-field', {
                staticClass: "flex-grow-0",
                attrs: {
                  "label": "Trial new name",
                  "disabled": _vm.state !== 'ready' || ((_vm$session$trials$_v5 = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v5 === void 0 ? void 0 : _vm$session$trials$_v5.status) === 'processing' || ((_vm$session$trials$_v6 = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v6 === void 0 ? void 0 : _vm$session$trials$_v6.status) === 'uploading',
                  "error": errors.length > 0,
                  "error-messages": errors[0],
                  "autocomplete": "off"
                },
                on: {
                  "keydown": [function ($event) {
                    if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                    $event.preventDefault();
                    return _vm.submitRenameTrial.apply(null, arguments);
                  }, function ($event) {
                    if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
                    $event.preventDefault();
                    _vm.trial_rename_dialog = false;
                  }]
                },
                model: {
                  value: _vm.trialNewName,
                  callback: function ($$v) {
                    _vm.trialNewName = $$v;
                  },
                  expression: "trialNewName"
                }
              })];
            }
          }], null, true)
        }), _c('v-spacer'), _c('v-btn', {
          staticClass: "text-right",
          attrs: {
            "disabled": invalid || ((_vm$session$trials$_v7 = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v7 === void 0 ? void 0 : _vm$session$trials$_v7.status) === 'processing' || ((_vm$session$trials$_v8 = _vm.session.trials[_vm.trial_rename_index]) === null || _vm$session$trials$_v8 === void 0 ? void 0 : _vm$session$trials$_v8.status) === 'uploading'
          },
          on: {
            "click": function ($event) {
              _vm.trial_rename_dialog = false;
              _vm.renameTrial(_vm.session.trials[_vm.trial_rename_index], _vm.trial_rename_index, _vm.trialNewName);
            }
          }
        }, [_vm._v(" Rename Trial ")])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "content-class": "compact-rename-dialog app-dialog",
      "max-width": "420",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.session_rename_dialog,
      callback: function ($$v) {
        _vm.session_rename_dialog = $$v;
      },
      expression: "session_rename_dialog"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "dialog-close-btn",
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function ($event) {
        _vm.session_rename_dialog = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "orange"
    }
  }, [_vm._v("mdi-rename-box")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v("Enter a new name for this session:")]), _c('ValidationObserver', {
    ref: "observer_session_rename",
    staticClass: "d-flex flex-column",
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref8) {
        var invalid = _ref8.invalid;
        return [_c('ValidationProvider', {
          attrs: {
            "rules": "required|alpha_dash_custom",
            "name": "Session name"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref9) {
              var errors = _ref9.errors;
              return [_c('v-text-field', {
                staticClass: "flex-grow-0",
                attrs: {
                  "label": "Session name",
                  "error": errors.length > 0,
                  "error-messages": errors[0],
                  "autocomplete": "off"
                },
                on: {
                  "keydown": [function ($event) {
                    if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                    $event.preventDefault();
                    return _vm.submitRenameSession.apply(null, arguments);
                  }, function ($event) {
                    if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
                    $event.preventDefault();
                    _vm.session_rename_dialog = false;
                  }]
                },
                model: {
                  value: _vm.sessionNewName,
                  callback: function ($$v) {
                    _vm.sessionNewName = $$v;
                  },
                  expression: "sessionNewName"
                }
              })];
            }
          }], null, true)
        }), _c('v-btn', {
          staticClass: "text-right",
          attrs: {
            "disabled": invalid
          },
          on: {
            "click": _vm.submitRenameSession
          }
        }, [_vm._v(" Rename Session ")])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "content-class": "app-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.trial_modify_tags,
      callback: function ($$v) {
        _vm.trial_modify_tags = $$v;
      },
      expression: "trial_modify_tags"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "dialog-close-btn",
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function ($event) {
        _vm.trial_modify_tags = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "orange"
    }
  }, [_vm._v("mdi-rename-box")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [((_vm$session$trials$_v9 = _vm.session.trials[_vm.trial_modify_tags_index]) === null || _vm$session$trials$_v9 === void 0 ? void 0 : _vm$session$trials$_v9.status) === 'processing' || ((_vm$session$trials$_v0 = _vm.session.trials[_vm.trial_modify_tags_index]) === null || _vm$session$trials$_v0 === void 0 ? void 0 : _vm$session$trials$_v0.status) === 'uploading' ? _c('p', {
    staticClass: "text-orange"
  }, [_vm._v(" You can't modify trial tags while it's being uploaded or processed. Please wait before attempting to modify the tags. ")]) : _c('p', [_vm._v(" Insert the tags for trial " + _vm._s((_vm$session$trials$_v1 = _vm.session.trials[_vm.trial_modify_tags_index]) === null || _vm$session$trials$_v1 === void 0 ? void 0 : _vm$session$trials$_v1.name) + ": ")]), _c('ValidationObserver', {
    ref: "observer_tr_tag",
    staticClass: "d-flex flex-column",
    attrs: {
      "tag": "div"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "Trial tags"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref0) {
        var errors = _ref0.errors;
        return [_c('v-autocomplete', {
          ref: "trialTagsSelect",
          attrs: {
            "clearable": "",
            "multiple": "",
            "item-title": "text",
            "item-value": "value",
            "label": "Trial Tags",
            "items": _vm.tagsOptions,
            "error": errors.length > 0,
            "error-messages": errors[0],
            "search-input": _vm.tag_search_input,
            "autocomplete": "off"
          },
          on: {
            "update:searchInput": function ($event) {
              _vm.tag_search_input = $event;
            },
            "update:search-input": function ($event) {
              _vm.tag_search_input = $event;
            },
            "change": function ($event) {
              _vm.tag_search_input = '';
            }
          },
          model: {
            value: _vm.trialNewTags,
            callback: function ($$v) {
              _vm.trialNewTags = $$v;
            },
            expression: "trialNewTags"
          }
        })];
      }
    }])
  }), _c('v-spacer'), _c('v-btn', {
    staticClass: "text-right",
    attrs: {
      "disabled": ((_vm$session$trials$_v10 = _vm.session.trials[_vm.trial_modify_tags_index]) === null || _vm$session$trials$_v10 === void 0 ? void 0 : _vm$session$trials$_v10.status) === 'processing' || ((_vm$session$trials$_v11 = _vm.session.trials[_vm.trial_modify_tags_index]) === null || _vm$session$trials$_v11 === void 0 ? void 0 : _vm$session$trials$_v11.status) === 'uploading'
    },
    on: {
      "click": function ($event) {
        _vm.trial_modify_tags = false;
        _vm.modifyTagsTrial(_vm.session.trials[_vm.trial_modify_tags_index], _vm.trial_modify_tags_index, _vm.trialNewTags);
      }
    }
  }, [_vm._v(" Apply Tags ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm.trialForTrashDialog ? _c('ConfirmDialog', {
    attrs: {
      "click-outside": _vm.clickOutsideDialogTrialHideMenu,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "icon": "mdi-close-circle",
      "icon-color": "red",
      "confirm-color": "red darken-1"
    },
    on: {
      "cancel": _vm.closeTrashDialog,
      "confirm": _vm.confirmTrashTrial
    },
    model: {
      value: _vm.remove_dialog,
      callback: function ($$v) {
        _vm.remove_dialog = $$v;
      },
      expression: "remove_dialog"
    }
  }, [_c('p', [_vm._v(" Do you want to trash trial " + _vm._s(_vm.trialForTrashDialog.name) + "? You will be able to restore it for 30 days. After that, this trial will be permanently removed. ")])]) : _vm._e(), _vm.trialForRestoreDialog ? _c('ConfirmDialog', {
    attrs: {
      "click-outside": _vm.clickOutsideDialogTrialHideMenu,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "icon": "mdi-undo-variant",
      "icon-color": "green"
    },
    on: {
      "cancel": _vm.closeRestoreDialog,
      "confirm": _vm.confirmRestoreTrial
    },
    model: {
      value: _vm.restore_dialog,
      callback: function ($$v) {
        _vm.restore_dialog = $$v;
      },
      expression: "restore_dialog"
    }
  }, [_c('p', [_vm._v(" Do you want to restore trial " + _vm._s(_vm.trialForRestoreDialog.name) + "? ")])]) : _vm._e(), _vm.trialForPermanentDeleteDialog ? _c('ConfirmDialog', {
    attrs: {
      "click-outside": _vm.clickOutsideDialogTrialHideMenu,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "icon": "mdi-close-circle",
      "icon-color": "red",
      "confirm-color": "red darken-1"
    },
    on: {
      "cancel": _vm.closePermanentDeleteDialog,
      "confirm": _vm.confirmPermanentDeleteTrial
    },
    model: {
      value: _vm.permanent_delete_dialog,
      callback: function ($$v) {
        _vm.permanent_delete_dialog = $$v;
      },
      expression: "permanent_delete_dialog"
    }
  }, [_c('p', [_vm._v(" Do you want to permanently delete trial " + _vm._s(_vm.trialForPermanentDeleteDialog.name) + "? This action cannot be undone. "), !_vm.trialForPermanentDeleteDialog.trashed ? _c('span', [_vm._v(" Use Trash to keep the ability to restore the trial.")]) : _vm._e()])]) : _vm._e(), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogTrialHideMenu,
      expression: "clickOutsideDialogTrialHideMenu"
    }],
    attrs: {
      "content-class": "app-dialog",
      "max-width": "fit-content",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.showAnalysisDialog,
      callback: function ($$v) {
        _vm.showAnalysisDialog = $$v;
      },
      expression: "showAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5 font-weight-bold pb-2"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-chart-box-outline")]), _vm._v(" Advanced Analysis ")], 1), _c('v-divider'), _vm.analysisFunctions.length > 0 ? _c('v-card-text', {
    staticClass: "pt-4"
  }, [(_vm$session = _vm.session) !== null && _vm$session !== void 0 && _vm$session.trials && _vm.session.trials[_vm.trial_analysis_index] ? _vm._l(_vm.analysisFunctions, function (func, index) {
    return _c('div', {
      key: func.id,
      ref: func.id,
      refInFor: true,
      attrs: {
        "item": func,
        "index": index
      }
    }, [_c('v-row', {
      staticClass: "align-center mb-2"
    }, [_c('v-col', {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('div', {
      staticClass: "font-weight-bold text-subtitle-1 d-flex align-center"
    }, [_c('span', [_vm._v(_vm._s(func.title))]), func.info.length > 0 ? _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "max-width": "320px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref1) {
          var on = _ref1.on;
          return [_c('v-icon', _vm._g({
            staticClass: "ml-1",
            attrs: {
              "small": "",
              "color": "grey"
            }
          }, on), [_vm._v(" mdi-help-circle-outline ")])];
        }
      }], null, true)
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(func.info.replace(/\n/g, '<br>'))
      }
    })]) : _vm._e()], 1)]), _c('v-col', {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": "5"
      }
    }, [_c('div', {
      staticClass: "text-body-2 grey--text text--darken-2"
    }, [_vm._v(_vm._s(func.description))])]), _c('v-col', {
      staticClass: "py-2 text-right",
      attrs: {
        "cols": "12",
        "sm": "3"
      }
    }, [func.trials.includes(_vm.session.trials[_vm.trial_analysis_index].id) ? _c('v-btn', {
      attrs: {
        "small": "",
        "color": _vm.analysisActionBtnColor,
        "dark": _vm.$vuetify.theme.dark,
        "elevation": "2",
        "disabled": _vm.session.trials[_vm.trial_analysis_index].id in func.trials
      }
    }, [_c('span', [_c('v-progress-circular', {
      staticClass: "mr-2",
      attrs: {
        "indeterminate": "",
        "color": "grey",
        "size": "14",
        "width": "2"
      }
    }), _vm._v(" Calculating... ")], 1)]) : _vm._e(), !func.trials.includes(_vm.session.trials[_vm.trial_analysis_index].id) && !(_vm.session.trials[_vm.trial_analysis_index].id in func.states) ? _c('v-btn', {
      attrs: {
        "small": "",
        "elevation": "2",
        "color": _vm.analysisActionBtnColor,
        "dark": _vm.$vuetify.theme.dark
      },
      on: {
        "click": function ($event) {
          var _vm$session$trials$_v12;
          return _vm.invokeAnalysisFunction(func.id, _vm.session.trials[_vm.trial_analysis_index].id, (_vm$session$trials$_v12 = _vm.session.trials[_vm.trial_analysis_index]) === null || _vm$session$trials$_v12 === void 0 ? void 0 : _vm$session$trials$_v12.name);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-play")]), _vm._v(" Run ")], 1) : _vm._e(), _vm.session.trials[_vm.trial_analysis_index].id in func.states && !func.trials.includes(_vm.session.trials[_vm.trial_analysis_index].id) ? _c('v-btn', {
      attrs: {
        "small": "",
        "elevation": "2",
        "color": _vm.analysisActionBtnColor,
        "dark": _vm.$vuetify.theme.dark
      },
      on: {
        "click": function ($event) {
          func.states[_vm.session.trials[_vm.trial_analysis_index].id].state === 'successfull' && func.states[_vm.session.trials[_vm.trial_analysis_index].id].dashboard_id != null && _vm.goToAnalysisDashboard(func.states[_vm.session.trials[_vm.trial_analysis_index].id].dashboard_id, _vm.session.trials[_vm.trial_analysis_index].id);
        }
      }
    }, [_c('span', {
      staticClass: "font-weight-bold",
      style: func.states[_vm.session.trials[_vm.trial_analysis_index].id].state == 'failed' ? 'color:red' : 'color:lightgreen'
    }, [_vm._v(_vm._s(func.states[_vm.session.trials[_vm.trial_analysis_index].id].state))]), _c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": "",
        "close-on-content-click": "",
        "content-class": "analysis-submenu"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref10) {
          var on = _ref10.on,
            attrs = _ref10.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "analysis-menu-btn",
            attrs: {
              "icon": "",
              "dark": _vm.$vuetify.theme.dark
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', {
      staticClass: "analysis-submenu-list"
    }, [_c('v-list-item', {
      attrs: {
        "link": "",
        "disabled": _vm.trial_analysis_index in func.trials
      },
      on: {
        "click": function ($event) {
          var _vm$session$trials$_v13;
          return _vm.invokeAnalysisFunction(func.id, _vm.session.trials[_vm.trial_analysis_index].id, (_vm$session$trials$_v13 = _vm.session.trials[_vm.trial_analysis_index]) === null || _vm$session$trials$_v13 === void 0 ? void 0 : _vm$session$trials$_v13.name);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-refresh")]), _vm._v(" Re-run ")], 1), func.states[_vm.session.trials[_vm.trial_analysis_index].id].dashboard_id != null && func.states[_vm.session.trials[_vm.trial_analysis_index].id].state == 'successfull' ? _c('v-list-item', {
      on: {
        "click": function ($event) {
          return _vm.goToAnalysisDashboard(func.states[_vm.session.trials[_vm.trial_analysis_index].id].dashboard_id, _vm.session.trials[_vm.trial_analysis_index].id);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("mdi-view-dashboard")]), _vm._v(" Analysis Dashboard ")], 1) : _vm._e(), _vm._l(func.states[_vm.session.trials[_vm.trial_analysis_index].id].menu, function (menu_item) {
      return _c('v-list-item', {
        key: menu_item.label,
        on: {
          "click": function ($event) {
            return _vm.requestDownloadMenuItem(_vm.session.trials[_vm.trial_analysis_index], menu_item);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": "",
          "small": ""
        }
      }, [_vm._v("mdi-download")]), _vm._v(" " + _vm._s(menu_item.label) + " ")], 1);
    })], 2)], 1)], 1) : _vm._e()], 1)], 1), index < _vm.analysisFunctions.length - 1 ? _c('v-divider', {
      staticClass: "my-3"
    }) : _vm._e()], 1);
  }) : _c('p', {
    staticClass: "mb-0 grey--text"
  }, [_vm._v("Select a trial to run analysis.")])], 2) : _c('v-card-text', {
    staticClass: "text-center py-8"
  }, [_c('v-icon', {
    attrs: {
      "size": "64",
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-function-variant")]), _c('p', {
    staticClass: "text-h6 grey--text mt-4"
  }, [_vm._v("No available functions")]), _c('p', {
    staticClass: "grey--text text--lighten-1"
  }, [_vm._v("There are no analysis functions available for this session.")])], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm.analysisFunctions.length > 0 ? _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-restore")]), _vm._v(" Reset results ")], 1) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.showTrialMenuSheet = false;
        _vm.selectedTrialForMenu = null;
        (_vm.session.trials[_vm.trial_analysis_index] || {}).isMenuOpen = false;
        _vm.showAnalysisDialog = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-close")]), _vm._v(" Close ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "trial-legend__item"
  }, [_c('span', {
    staticClass: "trial-legend__dot trial-legend__dot--done"
  }), _vm._v("Done ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "trial-legend__item"
  }, [_c('span', {
    staticClass: "trial-legend__dot trial-legend__dot--processing"
  }), _vm._v("Processing ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "trial-legend__item"
  }, [_c('span', {
    staticClass: "trial-legend__dot trial-legend__dot--error"
  }), _vm._v("Error ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "trial-legend__item"
  }, [_c('span', {
    staticClass: "trial-legend__dot trial-legend__dot--local"
  }), _vm._v("Saved on phone ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "white--text text-center mb-6 px-4"
  }, [_vm._v("Click the button below to start recording from the mobile app. Make sure you have the latest version of the OpenCap app (2.0+) installed. "), _c('a', {
    staticClass: "open-in-app-store-link",
    attrs: {
      "href": "https://apps.apple.com/us/app/opencap/id1630513242",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Get it on the App Store")]), _vm._v(".")]);

}]

export { render, staticRenderFns }